export default __webpack_public_path__ + "static/media/13t.fe9f059a.jpg";